import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppConfig } from './app.config';

@Injectable({
  providedIn: 'root'
})
export class CoursesService {

  public footerData: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public resultScroll:  BehaviorSubject<string> = new BehaviorSubject<string>('');
  public crashCourseScroll: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public moduleId: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public colorTheme: BehaviorSubject<string> = new BehaviorSubject<string>('');

  public menuNav: BehaviorSubject<string> = new BehaviorSubject<string>('');

  constructor(public http: HttpClient, public AppConfig: AppConfig) { }

  saveSelectedMenu(data:any){
    this.menuNav.next(data)
  }
  
  saveModuleData(data:any){
    this.moduleId.next(data)
  }

  saveResultScroll(data:any){
    this.resultScroll.next(data)
  }

  saveColorTheme(data:any){
    this.colorTheme.next(data)
  }

  //&eventType=live

  getFranchiseData(){
    return this.http.get('https://media.iquanta.in/ui_images/franchise-data.ts')
  }

  getCollegesList() {
    return this.http.get('https://media.iquanta.in/ui_images/33-colleges-data.json').pipe(map((response: any) => response));
  }

  getCollegeData(data:any){
    return this.http.get('https://api.insideiim.com/api/v1/bschool-comparison/?slugs='+data)
  }

 

  addCollegeLead(reqData: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
         'secret': '6669ac7eeb6f363a778463e0',
        'token': '6669ac7eeb6f363a778463e0'
      })
    };

    return this.http.post('https://itech-api-prod.iquanta.in/api/top-college/v1/sent/enquiry/college/data', reqData, httpOptions)
      .pipe(map((response: any) => response));
  }


  getResultData(reqData: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
         
      })
    };
  
    return this.http.post('https://itech-api-prod.iquanta.in/api/top-college/v1/sent/enquiry/extract', reqData)
      .pipe(map((response: any) => response));
  }

  getIITResults(reqData: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
         
      })
    };
  
    return this.http.post('https://itech-api-prod.iquanta.in/api/iit-result/v1/response/student', reqData)
      .pipe(map((response: any) => response));
  }

  getIITResultData(reqData: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
         
      })
    };
  
    return this.http.post('https://api.iverse.iquanta.in/api/student/connect/iit/calculateMarks/link', reqData)
      .pipe(map((response: any) => response));
  }

  getCmatResults(reqData: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
         
      })
    };
  
    return this.http.post('https://api.iverse.iquanta.in/api/student/connect/cmat/calculateMarks/link', reqData)
      .pipe(map((response: any) => response));
  }


  getAtsScore(reqData: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
         
      })
    };
  
    return this.http.post('https://itech-api-prod.iquanta.in/api/ats-calculator/v1/sent/enquiry', reqData)
      .pipe(map((response: any) => response));
  }

  getResultDataSaved(reqData: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
         
      })
    };
  
    return this.http.get('https://itech-api-prod.iquanta.in/api/cat-result/v1/student/'+reqData)
      .pipe(map((response: any) => response));
  }
  
  getTestimonials(){
    const httpOptions = {
      headers: new HttpHeaders({
        'secret': '6669ac7eeb6f363a778463e0',
        'token': '6669ac7eeb6f363a778463e0'
      })
    };

    return this.http.get('https://itech-api-prod.iquanta.in/api/cat-result/v1/testimonial/all/1/100' , httpOptions)
      .pipe(map((response: any) => response));
  }

  getStudentData(reqData: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
         
      })
    };
  
    return this.http.get('https://itech-api-prod.iquanta.in/api/cat-result/v1/result/student/'+reqData)
      .pipe(map((response: any) => response));
  }

  getLeaderBoardStudents(selectCount:any, pageCount:any, reqData:any){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
    
      })
    };

    return this.http.get('https://itech-api-prod.iquanta.in/api/cat-result/v1/result/student/leaderboard/'+reqData+'?page='+pageCount+'&limit='+selectCount,  httpOptions)
    .pipe(map((response: any) => response));

  }
  
  getYoutubeVideos() {
    let url = 'https://www.googleapis.com/youtube/v3/search?part=snippet&channelId=UCluniE65oSuRxbHPKKbXQsA&type=video&key=AIzaSyDbVVYvjg4GaMzMipCJn9GxNdaT5WQSC10'
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
         
      })
    };

    return this.http.get(url, httpOptions)
      .pipe(map((response: any) => response));
  }

  filterCourses(reqObj: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
         
      })
    };

    return this.http.post(this.AppConfig.API_ENDPOINT + 'course_filters', reqObj, httpOptions)
      .pipe(map((response: any) => response));
  }


  saveScroll(val: any) {
    this.footerData.next(val)
  }

  saveCrashScroll(val: any) {
    this.crashCourseScroll.next(val)
  }

  getConsultation(reqObj: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
 
      })
    };

    return this.http.post(this.AppConfig.API_ENDPOINT + 'gmat_consultation_post', reqObj, httpOptions)
      .pipe(map((response: any) => response));
  }



  getEnableAndDisabledCourses() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
 
      })
    };

    return this.http.get(this.AppConfig.API_ENDPOINT + 'AllCoursesGet', httpOptions)
      .pipe(map((response: any) => response));
  }

  getAllCourses() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
 
      })
    };

    return this.http.get(this.AppConfig.API_ENDPOINT + 'course', httpOptions)
      .pipe(map((response: any) => response));
  }

  getQuizPackages() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
 
      })
    };

    return this.http.get(this.AppConfig.API_ENDPOINT + 'quiz_package_details', httpOptions)
      .pipe(map((response: any) => response));
  }

  getVideosWatchTimeModuleBased(reqData: any, token: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };
  
    return this.http.get(this.AppConfig.LOGIN_ENDPOINT + 'view_total_videos_watch_time?course_id='+ reqData.course +'&user_id=' + reqData.id, httpOptions)
      .pipe(map((response: any) => response));
  }

  
getAssignmentCompletedData(reqData: any, token: any) {
  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Token ' + token
    })
  };

  return this.http.get(this.AppConfig.LOGIN_ENDPOINT + 'view_total_passages_hits?course_id='+reqData.courseId+'&user_id='+reqData.id, httpOptions)
    .pipe(map((response: any) => response));
}

getVideoCompletedData(reqData: any, token: any) {
  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Token ' + token
    })
  };

  return this.http.get(this.AppConfig.LOGIN_ENDPOINT + 'view_total_videos_hits?course_id='+reqData.courseId+'&user_id='+reqData.id, httpOptions)
    .pipe(map((response: any) => response));
}

saveVideoWatchTime(reqData: any, token: any) {
  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Token ' + token
    })
  };

  return this.http.post(this.AppConfig.LOGIN_ENDPOINT + 'submit_user_watched_video', reqData, httpOptions)
    .pipe(map((response: any) => response));
}


  getCourseCat(type: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
 
      })
    };

    return this.http.get(this.AppConfig.API_ENDPOINT1 + 'course_category?course_name=' + type, httpOptions)
      .pipe(map((response: any) => response));
  }

  courseDetails(id: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
 
      })
    };

    return this.http.get(this.AppConfig.API_ENDPOINT + 'course?course_id=' + id, httpOptions)
      .pipe(map((response: any) => response));
  }

  courseDetailsToken(id: any, token: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token,
 
      })
    };

    return this.http.get(this.AppConfig.API_ENDPOINT + 'course?course_id=' + id, httpOptions)
      .pipe(map((response: any) => response));
  }

  callback(reqData: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
 
      })
    };

    return this.http.post(this.AppConfig.API_ENDPOINT1 + 'call_back/', reqData, httpOptions)
      .pipe(map((response: any) => response));
  }

  hardCopyForm(token: any, reqData: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token,
         
      })
    };

    return this.http.post(this.AppConfig.LOGIN_ENDPOINT + 'Userdeliveryaddresslist', reqData, httpOptions)
      .pipe(map((response: any) => response));
  }

  addDeliveryAddress(token: any, reqData: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token,
         
      })
    };

    return this.http.post(this.AppConfig.API_ENDPOINT + 'CheckUserDeliveryAddres', reqData, httpOptions)
      .pipe(map((response: any) => response));
  }

  patnaCallback(reqData: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
 
      })
    };

    return this.http.post(this.AppConfig.API_ENDPOINT + 'patna_enquiry_form_post', reqData, httpOptions)
      .pipe(map((response: any) => response));
  }



  getSearchDetails(searchitem: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
 
      })
    };

    return this.http.get(this.AppConfig.API_ENDPOINT + 'search?search_field=' + searchitem, httpOptions)
      .pipe(map((response: any) => response));
  }

  getModules(token: any, id: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        // 'Authorization': 'Token ' + token,
         
      })
    };


    return this.http.get(this.AppConfig.API_ENDPOINT + 'module?course_id=' + id, httpOptions)
      .pipe(map((response: any) => response));
  }

  getVideos(token: any, id: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token,
         
      })
    };


    return this.http.get(this.AppConfig.API_ENDPOINT + 'video?module_id=' + id, httpOptions)
      .pipe(map((response: any) => response));
  }


  getCareers() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
         
      })
    }

    return this.http.get(this.AppConfig.API_ENDPOINT + 'job_get', httpOptions)
      .pipe(map((response: any) => response));
  }


  getnoncat() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
         
      })
    };


    return this.http.get(this.AppConfig.API_ENDPOINT1 + 'non_cat_courses?non_cat=True', httpOptions)
      .pipe(map((response: any) => response));
  }


  saveCustResults(reqData: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
         
      })
    };


    return this.http.post(this.AppConfig.API_ENDPOINT + 'cuet_results_create', reqData, {})
      .pipe(map((response: any) => response));
  }

  homeEnquiry(reqData: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
 
      })
    };

    return this.http.post(this.AppConfig.LOGIN_ENDPOINT + 'homepage_enquiry_form_post', reqData, httpOptions)
      .pipe(map((response: any) => response));
  }

  getProductDetails(id: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
         
      })
    };

    // return this.http.get(this.AppConfig.API_ENDPOINT + 'product_get?product_id=' + id, httpOptions)
    return this.http.get(this.AppConfig.API_ENDPOINT + 'ProductGetBasedOnName?product_name=' + id, httpOptions)

      .pipe(map((response: any) => response));
  }

  getProductDetailsById(id: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
         
      })
    };

    return this.http.get(this.AppConfig.API_ENDPOINT + 'product_get?product_id=' + id, httpOptions)

      .pipe(map((response: any) => response));
  }

  getBannerImages(id: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
         
      })
    };

    return this.http.get(this.AppConfig.API_ENDPOINT + 'ProductMobileOrDesktopImagesBasedOnProductID?product_id=' + id, httpOptions)

      .pipe(map((response: any) => response));
  }

  getFaqs(id: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
         
      })
    };


    return this.http.get(this.AppConfig.API_ENDPOINT + 'ProductFAQDetailsBasedOnProduct?product_id=' + id, httpOptions)
      .pipe(map((response: any) => response));
  }

  getUsersEnrolled(id: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
         
      })
    };


    return this.http.get(this.AppConfig.API_ENDPOINT + 'UsersEnrolledToProduct?product_id=' + id, httpOptions)
      .pipe(map((response: any) => response));
  }

  addToWishList(id: any, token: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token,
         
      })
    };


    return this.http.post(this.AppConfig.LOGIN_ENDPOINT + 'WishListPost', id, httpOptions)
      .pipe(map((response: any) => response));
  }

  getBannerVideos() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    return this.http.get(this.AppConfig.API_ENDPOINT1 + 'HomePageVideoList', httpOptions)
      .pipe(map((response: any) => response));
  }

  getNoticeBoards() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
         
      })
    };

    return this.http.get(this.AppConfig.API_ENDPOINT1 + 'NoticeBoardList', httpOptions)
      .pipe(map((response: any) => response));
  }

  getNoticeBoardPerPage(val: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
         
      })
    };

    return this.http.get(this.AppConfig.API_ENDPOINT1 + 'NoticeBoardList?page_type=' + val, httpOptions)
      .pipe(map((response: any) => response));
  }

  getPagewiseCourses(type: any, page: any, year: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
 
      })
    };

    return this.http.get(this.AppConfig.API_ENDPOINT + 'CoursesGetBasedOnCategoryAndYear?page_type=' + page + '&category_name=' + type + '&year=' + year, httpOptions)
      .pipe(map((response: any) => response));
  }

  getAllMocks() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'token': 'f61a6f71-2bc4-4b50-8fe0-e2694671207f',
        'secret': '7796b364-02d2-42db-990b-bc1973b68211',
      })
    };

    return this.http.get('https://adminapi.iqmock.iquanta.in/business/:page/:limit', httpOptions)
      .pipe(map((response: any) => response));
  }


  getCustomCourses(page: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
 
      })
    };

    return this.http.get(this.AppConfig.API_ENDPOINT + 'CustomCourseDetailsBasedOnCategory?category=' + page, httpOptions)
      .pipe(map((response: any) => response));
  }

  getFooterNotifi(exam: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
         
      })
    };

    return this.http.get(this.AppConfig.API_ENDPOINT + 'GetFooter_by_exam_name?exam_name=' + exam, httpOptions)
      .pipe(map((response: any) => response));
    // return this.http.get(this.AppConfig.API_ENDPOINT + 'FooterGet', httpOptions)
    //   .pipe(map((response: any) => response));
  }

  getAllFooterNotifications() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
         
      })
    };

    return this.http.get(this.AppConfig.API_ENDPOINT + 'FooterGet', httpOptions)
      .pipe(map((response: any) => response));
  }

  getTestMockStatus(reqObj: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'token': 'f61a6f71-2bc4-4b50-8fe0-e2694671207f',
        'secret': '7796b364-02d2-42db-990b-bc1973b68211',
         
      })
    };

    // return this.http.get('https://adminapi.iqmock.iquanta.in/business/mockstatus/' + reqObj.uid + '/' + reqObj.id, httpOptions)
      return this.http.get('https://adminapi.iverse.iquanta.in/platform/v1/connect/test/status/'+reqObj.id+'/'+reqObj.uid, httpOptions)
      .pipe(map((response: any) => response));
  }

  getDevMockStatus(reqObj: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'token': 'f61a6f71-2bc4-4b50-8fe0-e2694671207f',
        'secret': '7796b364-02d2-42db-990b-bc1973b68211',
         
      })
    };

    // return this.http.get('https://adminapi.iqmock.iquanta.in/business/mockstatus/' + reqObj.uid + '/' + reqObj.id, httpOptions)
      return this.http.get('https://dev.iverse.iquanta.in/platform/v1/connect/test/status/'+reqObj.id+'/'+reqObj.uid, httpOptions)
      .pipe(map((response: any) => response));
  }


  getMockStatus(reqObj: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'token': 'f61a6f71-2bc4-4b50-8fe0-e2694671207f',
        'secret': '7796b364-02d2-42db-990b-bc1973b68211',
         
      })
    };

    return this.http.get('https://adminapi.iqmock.iquanta.in/business/mockstatus/' + reqObj.uid + '/' + reqObj.id, httpOptions)
      // return this.http.get('https://adminapi.iverse.iquanta.in/platform/v1/connect/test/status/'+reqObj.id+'/'+reqObj.uid, httpOptions)
      .pipe(map((response: any) => response));
  }

  getXatStatus(reqObj: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'token': 'f61a6f71-2bc4-4b50-8fe0-e2694671207f',
        'secret': '7796b364-02d2-42db-990b-bc1973b68211',
         
      })
    };

    return this.http.get('https://adminapi.iverse.iquanta.in/platform/v1/connect/status/' + reqObj.id + '/' + reqObj.uid, httpOptions)
      .pipe(map((response: any) => response));
  }

  getSectionalMockStatus(reqObj: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'token': 'f61a6f71-2bc4-4b50-8fe0-e2694671207f',
        'secret': '7796b364-02d2-42db-990b-bc1973b68211',
         
      })
    };

    return this.http.get('https://adminapi.iqmock.iquanta.in/business/sectionalmockstatus/' + reqObj.uid + '/' + reqObj.id, httpOptions)
      .pipe(map((response: any) => response));
  }

  getMockLinks() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
         
      })
    };

    return this.http.get(this.AppConfig.API_ENDPOINT + 'MockUrlList', httpOptions)
      .pipe(map((response: any) => response));
  }

  saveFeeWaiver(fd: any) {
    return this.http.post(this.AppConfig.API_ENDPOINT + 'MockFeeWaiverList', fd)
      .pipe(map((response: any) => response));
  }

  saveGDPIFeeWaiver(fd: any) {
    return this.http.post(this.AppConfig.API_ENDPOINT + 'GDPIMockFeeWaiverList', fd)
      .pipe(map((response: any) => response));
  }

  getOtp(email: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'token': 'f61a6f71-2bc4-4b50-8fe0-e2694671207f',
        'secret': '7796b364-02d2-42db-990b-bc1973b68211',
         
      })
    };

    return this.http.post('https://adminapi.iqmock.iquanta.in/business/otp/' + email, {}, httpOptions)
      .pipe(map((response: any) => response));
  }

  resetAccount(email: any, id:any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'secret':'667e6a7d3a9e0fc886a4cfa5667e6a7d3a9e0fc886a4cfa5',
        'token':'650445c6fc904d452998918c650445c6fc904d452998918c',
         
      })
    };

    return this.http.delete('https://api.iverse.iquanta.in/api/student/v1/verify/reset/'+email+'/' + id, httpOptions)
      .pipe(map((response: any) => response));
  }

  getProductBanner(id: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
         
      })
    };

    return this.http.get(this.AppConfig.API_ENDPOINT + 'ProductBannerBasedOnProduct?product_id=' + id, httpOptions)
      .pipe(map((response: any) => response));
  }

  getMocks() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'token': 'f61a6f71-2bc4-4b50-8fe0-e2694671207f',
        'secret': '7796b364-02d2-42db-990b-bc1973b68211',
         
      })
    };

    return this.http.get('https://adminapi.iqmock.iquanta.in/business/sectional/:page/:limit', httpOptions)
      .pipe(map((response: any) => response));
  }

  getLandingPageDetails(page: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
 
      })
    };

    return this.http.get(this.AppConfig.API_ENDPOINT + 'LandingPageAllDataBasedOnId?landing_page_name=' + page, httpOptions)
      .pipe(map((response: any) => response));
  }

  getUserAddress(token: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token,
         
      })
    };

    return this.http.get(this.AppConfig.LOGIN_ENDPOINT + 'CheckUserdeliveryAdressList', httpOptions)
      .pipe(map((response: any) => response));
  }

  addOfflineTraining(reqData: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
         
      })
    };


    return this.http.post(this.AppConfig.API_ENDPOINT + 'CatOffline_post', reqData, httpOptions)
      .pipe(map((response: any) => response));
  }


  submitiStarRequest(fd: any, token: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'Token ' + token,
         
      })
    };

    return this.http.post(this.AppConfig.API_ENDPOINT + 'IstarFormPost', fd, httpOptions)
      .pipe(map((response: any) => response));
  }

  submitRequest(fd: any, token: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'Token ' + token,
         
      })
    };

    return this.http.post('https://itech-api-prod.iquanta.in/api/istar/v1/iim-calls/sent/iima', fd, httpOptions)
      .pipe(map((response: any) => response));
  }


getMocksBasedOnPages(){
  return this.http.get('https://mbrdigital.net/uidev/angular/iquanta/assets/js/exams.mock_packages.json')
}

getMocksOnId(id:any){
  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'token': 'f61a6f71-2bc4-4b50-8fe0-e2694671207f',
      'secret': '7796b364-02d2-42db-990b-bc1973b68211',
       
    })
  };

  return this.http.get('https://iv-admin-prod.iverse.iquanta.in/exams/v1/business/mbr/mocks/'+id, httpOptions)
    .pipe(map((response: any) => response));
}

getStrategyBuilder(reqData: any) {
  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
       
    })
  };

  return this.http.post('https://itech-api.dev.iquanta.in/api/cat-strategy/v1/add/basic/'+reqData.mbrId, reqData, httpOptions)
    .pipe(map((response: any) => response));
}

getUserStrategyData(reqData: any) {
  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
       
    })
  };

  return this.http.get('https://itech-api.dev.iquanta.in/api/cat-strategy/v1/retrieve/basic/'+reqData, httpOptions)
    .pipe(map((response: any) => response));
}

updateStrategyBuilder(reqData: any, id:any) {
  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
       
    })
  };

  return this.http.patch('https://itech-api.dev.iquanta.in/api/cat-strategy/v1/update/basic/'+id, {dateWiseSubjectReport: reqData} , httpOptions)
    .pipe(map((response: any) => response));
}

restructureStrategyBuilder(reqData: any, id:any, days:any) {
  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
       
    })
  };

  return this.http.patch('https://itech-api.dev.iquanta.in/api/cat-strategy/v1/update/basic/'+id,  reqData , httpOptions)
    .pipe(map((response: any) => response));
}

submitlrdienquiry(reqData: any) {
  const httpOptions = {
    headers: new HttpHeaders({
      'token': 'f61a6f71-2bc4-4b50-8fe0-e2694671207f',
      'secret': '7796b364-02d2-42db-990b-bc1973b68211',
       
    })
  };

  return this.http.post('https://itech-api-prod.iquanta.in/api/lrdiInception/v1/sent/enquiry', reqData, httpOptions)
    .pipe(map((response: any) => response));
}

getCatLrdiVideos(){
  return this.http.get('https://media.iquanta.in/cat-lrdi-videos.json')
  .pipe(map((response: any) => response));
}

getColleges(reqObj:any) {
  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'secret': '6669ac7eeb6f363a778463e0',
        'token': '6669ac7eeb6f363a778463e0'
    })
  };

  return this.http.get('https://itech-api-prod.iquanta.in/api/top-college/v1/all/'+reqObj.pageIndex+'/'+reqObj.pageSize, httpOptions)
    .pipe(map((response: any) => response));
}

getOverviewResponse(reqObj:any) {
  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'secret': '6669ac7eeb6f363a778463e0',
        'token': '6669ac7eeb6f363a778463e0'
    })
  };

  return this.http.post('https://itech-api-prod.iquanta.in/api/indra-ai/v1/bot/query/sendQuery', reqObj, httpOptions)
    .pipe(map((response: any) => response));
}

sendFeedback(token:any, reqObj:any) {
  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Token ' + token,
    })
  };

  return this.http.post(this.AppConfig.LOGIN_ENDPOINT + 'postfeeback', reqObj, httpOptions)
    .pipe(map((response: any) => response));
}

sendErrorReport(token:any, reqObj:any) {
  const httpOptions = {
    headers: new HttpHeaders({
      'Authorization': 'Token ' + token,
    })
  };

  return this.http.post(this.AppConfig.LOGIN_ENDPOINT + 'postusererror', reqObj, httpOptions)
    .pipe(map((response: any) => response));
}

saveNotes(token:any, reqObj:any) {
  const httpOptions = {
    headers: new HttpHeaders({
      'Authorization': 'Token ' + token,
    })
  };

  return this.http.post(this.AppConfig.LOGIN_ENDPOINT + 'Videos_Notes', reqObj, httpOptions)
    .pipe(map((response: any) => response));
}

getVideoNotes(token:any, reqObj:any) {
  const httpOptions = {
    headers: new HttpHeaders({
      'Authorization': 'Token ' + token,
    })
  };

  return this.http.get(this.AppConfig.LOGIN_ENDPOINT + 'Videos_Notes?video_id='+reqObj.video_id+'&user_id='+reqObj.user_id, reqObj)
    .pipe(map((response: any) => response));
}

scheduleCall(token:any, reqObj:any) {
  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Token ' + token,
    })
  };

  return this.http.post('https://itech-api-prod.iquanta.in/api/ai-mock-interview/v1/schedule/set/call', reqObj, httpOptions)
    .pipe(map((response: any) => response));
}

getScheduleCalls(token:any, reqObj:any) {
  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Token ' + token,
    })
  };

  return this.http.get('https://itech-api-prod.iquanta.in/api/ai-mock-interview/v1/schedule/individual/all/calls/'+reqObj+'/1/100',  httpOptions)
    .pipe(map((response: any) => response));
}

getCallDetails(token:any, reqObj:any) {
  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Token ' + token,
    })
  };

  return this.http.get('https://itech-api-prod.iquanta.in/api/ai-mock-interview/v1/call/individual/one/start/'+reqObj,  httpOptions)
    .pipe(map((response: any) => response));
}

getProducts(reqObj:any) {
  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    })
  };

  return this.http.get('https://itech-api-prod.iquanta.in/api/ai-mock-interview/v1/product/all/exams/calls/'+reqObj.id+'/'+reqObj.subid+'/:page/:limit',  httpOptions)
    .pipe(map((response: any) => response));
}

addCreditsToAccount(token:any, reqObj:any) {
  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Token ' + token,
    })
  };

  return this.http.post('https://itech-api-prod.iquanta.in/api/ai-mock-interview/v1/payment/create/new', reqObj, httpOptions)
    .pipe(map((response: any) => response));
}

getUserCredits(reqObj:any) {
  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    })
  };

  return this.http.get('https://itech-api-prod.iquanta.in/api/ai-mock-interview/v1/user/single/one/'+reqObj, httpOptions)
    .pipe(map((response: any) => response));
}

addUserInCRM(reqObj:any) {
  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    })
  };

  return this.http.post('https://itech-api-prod.iquanta.in/api/ai-mock-interview/v1/user/create/user', reqObj, httpOptions)
    .pipe(map((response: any) => response));
}

getMockTypes(reqObj:any) {
  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    })
  };

  return this.http.get('https://iv-admin-prod.iverse.iquanta.in/exams/v1/business/mbr/entityType/categoryPackageList?entityType='+reqObj, httpOptions)
    .pipe(map((response: any) => response));
}

getMocksBasedonType(reqObj:any) {
  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    })
  };

  return this.http.get('https://iv-admin-prod.iverse.iquanta.in/exams/v1/business/mbr/mockList/'+reqObj, httpOptions)
    .pipe(map((response: any) => response));
}

// Practice Tool APIs Start

getDailyTargets(reqObj:any) {
  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    })
  };

  //return this.http.get('https://itech-api-prod.iquanta.in/api/cat-daily-target/v1/mock/all/mocks/'+reqObj+'/:page/:limit', httpOptions)
  
  return this.http.get('https://itech-api-prod.iquanta.in/api/cat-daily-target/v1/cat-clock/today-mock/'+reqObj, httpOptions)
    .pipe(map((response: any) => response));
}


getLeaderBoardList(reqObj:any) {
  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    })
  };

  return this.http.get('https://itech-api-prod.iquanta.in/api/cat-daily-target/v1/mock/all/leaderboard/'+reqObj.id+'?filterBy='+reqObj.filter+'&sortBy='+reqObj.sort+'&sortSubjectBy='+reqObj.sortSubjectBy, httpOptions)
    .pipe(map((response: any) => response));
}

getUserDailyTargets(reqObj:any) {
  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    })
  };

  return this.http.get('https://itech-api-prod.iquanta.in/api/cat-daily-target/v1/mock/all/dailyTarget/'+reqObj.id+'?startDate='+reqObj.start+'&endDate='+reqObj.end, httpOptions)
    .pipe(map((response: any) => response));
  // const httpOptions = {
  //   headers: new HttpHeaders({
  //     'Content-Type': 'application/json',
  //   })
  // };

  // return this.http.get('https://itech-api-prod.iquanta.in/api/cat-daily-target/v1/mock/multiple/dailyTarget/'+reqObj.id+'?startDate='+reqObj.start+'&endDate='+reqObj.end, httpOptions)
  //   .pipe(map((response: any) => response));
}

getSearchFriends(reqObj:any) {
  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    })
  };

  return this.http.get('https://api.iverse.iquanta.in/api/student/v1/mock/search/users?name='+reqObj.name, httpOptions)
    .pipe(map((response: any) => response));
}

getAllMockData(reqObj:any) {
  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    })
  };

  return this.http.get('https://itech-api-prod.iquanta.in/api/cat-daily-target/v1/mock/all/mocks/'+reqObj.id+'/:page/:limit?filterType=custom&searchQuery='+reqObj.query+'&startDate='+reqObj.start+'&endDate='+reqObj.end, httpOptions)
    .pipe(map((response: any) => response));
}

getCustomMocks(reqObj:any) {
  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    })
  };

  return this.http.get('https://itech-api-prod.iquanta.in/api/cat-daily-target/v1/cat-clock/all-filtered-mock?uid='+reqObj.id+'&dateFilter='+reqObj.filter+'&startDate='+reqObj.start+'&endDate='+reqObj.end+'&topic='+reqObj.topic+'&subtopic=&subjectId='+reqObj.subject+'&searchQuery='+reqObj.search+'&page='+reqObj.page+'&limit='+reqObj.limit, httpOptions)
    .pipe(map((response: any) => response));
}

getDailyTargetProduct(reqObj:any) {
  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    })
  };

  return this.http.get('https://itech-api-prod.iquanta.in/api/cat-daily-target/v1/product/single/'+reqObj, httpOptions)
    .pipe(map((response: any) => response));
}


dailyTargetPurchase(reqData:any) {
  const httpOptions = {
    headers: new HttpHeaders({
      'secret': '6669ac7eeb6f363a778463e0',
      'token': '6669ac7eeb6f363a778463e0'
    })
  };

  return this.http.post('https://itech-api-prod.iquanta.in/api/cat-daily-target/v1/payment/create/new', reqData, httpOptions)
    .pipe(map((response: any) => response));
}

getUserPackages(reqData:any) {
  const httpOptions = {
    headers: new HttpHeaders({
      'secret': '6669ac7eeb6f363a778463e0',
      'token': '6669ac7eeb6f363a778463e0'
    })
  };

  return this.http.get('https://itech-api-prod.iquanta.in/api/cat-daily-target/v1/payment/individual/all/list/'+reqData.id+'/'+reqData.productId+'/:page/:limit', httpOptions)
    .pipe(map((response: any) => response));
}

getDaysLeft() {
  const httpOptions = {
    headers: new HttpHeaders({
      'secret': '6669ac7eeb6f363a778463e0',
      'token': '6669ac7eeb6f363a778463e0'
    })
  };

  return this.http.get('https://itech-api-prod.iquanta.in/api/cat-daily-target/v1/cat-clock/info')
    .pipe(map((response: any) => response));
}

getRandomUsers() {
  const httpOptions = {
    headers: new HttpHeaders({
      'secret': '6669ac7eeb6f363a778463e0',
      'token': '6669ac7eeb6f363a778463e0'
    })
  };

  return this.http.get('https://api.iverse.iquanta.in/api/student/v1/mock/random/users')
    .pipe(map((response: any) => response));
}

getAnalytics(reqObj:any) {
  const httpOptions = {
    headers: new HttpHeaders({
      'secret': '6669ac7eeb6f363a778463e0',
      'token': '6669ac7eeb6f363a778463e0'
    })
  };

  return this.http.get('https://api.iverse.iquanta.in/api/student/v1/mock/analytics/user/'+reqObj.id+'?filterType='+reqObj.filter)
    .pipe(map((response: any) => response));
}

getMyFriendsList(reqObj:any) {
  const httpOptions = {
    headers: new HttpHeaders({
      'secret': '6669ac7eeb6f363a778463e0',
      'token': '6669ac7eeb6f363a778463e0'
    })
  };

  return this.http.get('https://itech-api-prod.iquanta.in/api/cat-daily-target/v1/friend/all/list/'+reqObj.id+'/:page/:limit')
    .pipe(map((response: any) => response));
}

addToMyFriends(reqObj:any) {
  const httpOptions = {
    headers: new HttpHeaders({
      'secret': '6669ac7eeb6f363a778463e0',
      'token': '6669ac7eeb6f363a778463e0'
    })
  };

  return this.http.post('https://itech-api-prod.iquanta.in/api/cat-daily-target/v1/friend/create/new', reqObj)
    .pipe(map((response: any) => response));
}

challengeFriend(reqObj:any) {
  const httpOptions = {
    headers: new HttpHeaders({
      'secret': '6669ac7eeb6f363a778463e0',
      'token': '6669ac7eeb6f363a778463e0'
    })
  };

  return this.http.post('https://itech-api-prod.iquanta.in/api/cat-daily-target/v1/challenge/create/new', reqObj)
    .pipe(map((response: any) => response));
}

getChallenges(url:any) {
  const httpOptions = {
    headers: new HttpHeaders({
      'secret': '6669ac7eeb6f363a778463e0',
      'token': '6669ac7eeb6f363a778463e0'
    })
  };

  return this.http.get(url)
    .pipe(map((response: any) => response));
}

getTopicsAndSubTopics(id:any){
  const httpOptions = {
    headers: new HttpHeaders({
      'secret': '6669ac7eeb6f363a778463e0',
      'token': '6669ac7eeb6f363a778463e0'
    })
  };

  return this.http.get('https://itech-api-prod.iquanta.in/api/cat-daily-target/v1/mock/all/topics/'+id+'/:page/:limit')
    .pipe(map((response: any) => response));
}

updateChallenge(reqObj:any){
  const httpOptions = {
    headers: new HttpHeaders({
      'secret': '6669ac7eeb6f363a778463e0',
      'token': '6669ac7eeb6f363a778463e0'
    })
  };

  return this.http.patch('https://itech-api-prod.iquanta.in/api/cat-daily-target/v1/challenge/update/'+reqObj.id,reqObj)
    .pipe(map((response: any) => response));
}

getDreamTeamStatus(id:any){
  const httpOptions = {
    headers: new HttpHeaders({
      'secret': '6669ac7eeb6f363a778463e0',
      'token': '6669ac7eeb6f363a778463e0'
    })
  };

  return this.http.get('https://itech-api-prod.iquanta.in/api/cat-daily-target/v1/mock/all/dream/'+id)
    .pipe(map((response: any) => response));
}

getSyllabusStatus(id:any){
  const httpOptions = {
    headers: new HttpHeaders({
      'secret': '6669ac7eeb6f363a778463e0',
      'token': '6669ac7eeb6f363a778463e0'
    })
  };

  return this.http.get('https://itech-api-prod.iquanta.in/api/cat-daily-target/v1/mock/my/performance/'+id)
    .pipe(map((response: any) => response));
}

getChannels(){
  const httpOptions = {
    headers: new HttpHeaders({
      'secret': '6669ac7eeb6f363a778463e0',
      'token': '6669ac7eeb6f363a778463e0'
    })
  };

  return this.http.get('https://cheriskope-api.dev.iquanta.in/api/v1/community/channel/all/list/:page/:limit')
    .pipe(map((response: any) => response));
}

getChannelBasedMessages(reqObj:any){
  const httpOptions = {
    headers: new HttpHeaders({
      'secret': '6669ac7eeb6f363a778463e0',
      'token': '6669ac7eeb6f363a778463e0'
    })
  };

  return this.http.get('https://cheriskope-api.dev.iquanta.in/api/v1/community/message/all/list/'+reqObj.channel+'/'+reqObj.page+'/:limit')
    .pipe(map((response: any) => response));
}

sendMessage(reqObj:any){
  const httpOptions = {
    headers: new HttpHeaders({
      'secret': '6669ac7eeb6f363a778463e0',
      'token': '6669ac7eeb6f363a778463e0'
    })
  };

  return this.http.post('https://cheriskope-api.dev.iquanta.in/api/v1/community/message/create/new', reqObj)
    .pipe(map((response: any) => response));
}

reactToMessage(reqObj:any){
  const httpOptions = {
    headers: new HttpHeaders({
      'secret': '6669ac7eeb6f363a778463e0',
      'token': '6669ac7eeb6f363a778463e0'
    })
  };

  return this.http.post('https://cheriskope-api.dev.iquanta.in/api/v1/community/react/message/new', reqObj)
    .pipe(map((response: any) => response));
}

// Practice Tool APIs End

editClass(token:any, reqData:any, id:any) {
  const httpOptions = {
    headers: new HttpHeaders({
      'secret': '6669ac7eeb6f363a778463e0',
      'token': '6669ac7eeb6f363a778463e0'
    })
  };

  return this.http.patch('https://itech-api-prod.iquanta.in/api/mbr/class/v1/update/' + id, reqData, httpOptions)
    .pipe(map((response: any) => response));
}

addClass(token:any, reqData:any) {
  const httpOptions = {
    headers: new HttpHeaders({
      'secret': '6669ac7eeb6f363a778463e0',
      'token': '6669ac7eeb6f363a778463e0'
    })
  };

  return this.http.post('https://itech-api-prod.iquanta.in/api/mbr/class/v1/sent/enquiry', reqData, httpOptions)
    .pipe(map((response: any) => response));
}

addClassVideo(token:any, reqData:any) {
  const httpOptions = {
    headers: new HttpHeaders({
      'secret': '6669ac7eeb6f363a778463e0',
      'token': '6669ac7eeb6f363a778463e0'
    })
  };

  return this.http.post('https://itech-api-prod.iquanta.in/api/mbr/class/v1/sent/vdo-cipher/enquiry', reqData, httpOptions)
    .pipe(map((response: any) => response));
}


saveUserLEadForm(reqData:any) {
  const httpOptions = {
    headers: new HttpHeaders({
      'secret': '6669ac7eeb6f363a778463e0',
      'token': '6669ac7eeb6f363a778463e0'
    })
  };

  return this.http.post('https://itech-api-prod.iquanta.in/api/mbr/home/v1/sent/enquiry', reqData, httpOptions)
    .pipe(map((response: any) => response));
}

updateUserLeadForm(reqData:any, id:any) {
  const httpOptions = {
    headers: new HttpHeaders({
      'secret': '6669ac7eeb6f363a778463e0',
      'token': '6669ac7eeb6f363a778463e0'
    })
  };

  return this.http.patch('https://itech-api-prod.iquanta.in/api/mbr/home/v1/update/'+id, reqData, httpOptions)
    .pipe(map((response: any) => response));
}

getFakeNumber(id:any) {
  const httpOptions = {
    headers: new HttpHeaders({
      'secret': '6669ac7eeb6f363a778463e0',
      'token': '6669ac7eeb6f363a778463e0'
    })
  };

  return this.http.get('https://itech-api-prod.iquanta.in/api/auth/v1/scholashipCount/'+id)
    .pipe(map((response: any) => response));
}

addFaculty(reqObj:any) {
  return this.http.post(this.AppConfig.API_ENDPOINT1 + 'FacultyImageUpload', reqObj)
    .pipe(map((response: any) => response));
}

uploadUserScoreCard(reqObj:any) {
  return this.http.post('https://itech-api-prod.iquanta.in/api/upload/v1/file', reqObj)
    .pipe(map((response: any) => response));
}


getBatchByCourseId(id:any) {
  const httpOptions = {
    headers: new HttpHeaders({
      'secret': '6669ac7eeb6f363a778463e0',
      'token': '6669ac7eeb6f363a778463e0'
    })
  };

  return this.http.get('https://itech-api-prod.iquanta.in/api/mbr/batch/v1/all/course/'+id+'/:page/:limit')
    .pipe(map((response: any) => response));
}





}
